import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["end"];
import React from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';

function ButtonGroup(_ref) {
  var end = _ref.end,
      props = _objectWithoutProperties(_ref, _excluded);

  var token = useToken();
  var spacing = token('button.group.spacing', token('spacing.s'));
  var mt = token('button.group.margin.top');
  return /*#__PURE__*/React.createElement(Box, _extends({
    spacing: spacing,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: end ? 'flex-end' : 'flex-start',
    mt: mt
  }, props));
}

export default ButtonGroup;